/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../../../../../common";
import type {
  MoarBase,
  MoarBaseInterface,
} from "../../../../../../../../contracts/submodules/moar-locker/submodules/moar/contracts/moar/MoarBase";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
      {
        internalType: "address",
        name: "royaltyAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ApprovalToOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "ArrayLengthMismatch",
    type: "error",
  },
  {
    inputs: [],
    name: "BurnningInactive",
    type: "error",
  },
  {
    inputs: [],
    name: "MetadataFrozen",
    type: "error",
  },
  {
    inputs: [],
    name: "NonAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "NonERC721ReceiverImplementer",
    type: "error",
  },
  {
    inputs: [],
    name: "NonExistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrOperator",
    type: "error",
  },
  {
    inputs: [],
    name: "RoyaltyPercentageExceed",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferDeactive",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferLocked",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferLockedByAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAddress",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "locked",
        type: "bool",
      },
    ],
    name: "LockTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "burningActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "locked",
        type: "bool",
      },
    ],
    name: "lockTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        internalType: "bool[]",
        name: "locks",
        type: "bool[]",
      },
    ],
    name: "lockTransfers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "metadataFrozen",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "royaltyReceiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyPercentage",
        type: "uint256",
      },
    ],
    name: "setRoyaltyInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "flag",
        type: "uint256",
      },
    ],
    name: "toggleFlag",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "transferDeactive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "transferLocks",
    outputs: [
      {
        internalType: "enum MoarBase.LockStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type MoarBaseConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MoarBaseConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MoarBase__factory extends ContractFactory {
  constructor(...args: MoarBaseConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    admin: PromiseOrValue<string>,
    royaltyAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<MoarBase> {
    return super.deploy(
      admin,
      royaltyAddress,
      overrides || {}
    ) as Promise<MoarBase>;
  }
  override getDeployTransaction(
    admin: PromiseOrValue<string>,
    royaltyAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(admin, royaltyAddress, overrides || {});
  }
  override attach(address: string): MoarBase {
    return super.attach(address) as MoarBase;
  }
  override connect(signer: Signer): MoarBase__factory {
    return super.connect(signer) as MoarBase__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MoarBaseInterface {
    return new utils.Interface(_abi) as MoarBaseInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MoarBase {
    return new Contract(address, _abi, signerOrProvider) as MoarBase;
  }
}
